import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import {Typography} from '@nur-portal/ui-kit';

import {CloseIcon} from '../../../modules/comments/components/modal-comments/close-icon';
import {getIconUrl, getShareUrl} from '../../../services/content-type/share-modal';
import {LIST_SHARE_NETWORKS} from '../../constants/sharing';

import styles from './sharing-widget.module.css';

const SharingWidget = ({
  onShare,
  onClose,
  url,
  title,
  onCopy,
  utmMedium
}) => {
  const copyButtonRef = useRef();
  const {t} = useTranslation();

  const onSocialClick = type => {
    onShare(type);
  };

  const onCopyClick = () => {
    import('../../../services/content-type/copy-to-clipboard').then(module => {
      module.default(url, copyButtonRef.current);
    });
    onCopy();
  };

  return (
    <div className={styles.container}>
      <CloseIcon className={styles.closeIcon} onClick={() => onClose('')} />
      <Typography variant='title-16' className={styles.title}>{t('share.title')}</Typography>
      <button className={styles.item} onClick={onCopyClick} ref={copyButtonRef}>
        <img src={getIconUrl('social-icons/new/copy-link')} alt="copy" className={styles.itemImage} />
        <Typography variant='text-16' className={styles.itemText} component="span">{t('share.copy')}</Typography>
      </button>
      {LIST_SHARE_NETWORKS.map(({icon, type: socialType, name, baseUrl}) => (
        <a
          href={
            getShareUrl({
              articleUrl: url,
              title,
              type: socialType,
              baseUrl,
              utmMedium
            })}
          target="_blank"
          className={styles.item}
          onClick={() => onSocialClick(socialType)}
          key={name}
          rel="noreferrer"
        >
          <img className={styles.itemImage} src={getIconUrl(`social-icons/new/${icon}`)} alt={name} />
          <Typography variant='text-16' className={styles.itemText} component="span">{name}</Typography>
        </a>
      ))}
    </div>
  );
};

SharingWidget.propTypes = {
  onShare: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onCopy: PropTypes.func.isRequired,
  utmMedium: PropTypes.string.isRequired
};

export {SharingWidget};
